import { Button } from '@gerdau/hefesto/Button';
import { Title } from '@gerdau/hefesto/Title';
import React from 'react';
import {
  ETowerOption,
  IConstructionData
} from '../../../../../store/ducks/contracts-and-constructions/types';
import { ConstructionRegistrationResumeBlock } from '../styles';
import {
  ConstructionDataContainerBlock,
  ConstructionDataItemContainer
} from './styles';

interface IConstructionDataResumeProps {
  constructionData?: IConstructionData;
  onEditClick: () => void;
}

const ConstructionDataResume: React.FC<IConstructionDataResumeProps> = ({
  constructionData,
  onEditClick
}) => {
  return (
    <ConstructionRegistrationResumeBlock>
      <header>
        <Title level={2}>Dados da obra</Title>
        <Button name="edit" variant="secondary" onClick={onEditClick}>
          Editar
        </Button>
      </header>

      <ConstructionDataContainerBlock>
        <ConstructionDataItemContainer>
          <Title level={6}>CNPJ da matriz (emissor)</Title>

          <span className="description">{constructionData?.emitterCNPJ}</span>
        </ConstructionDataItemContainer>

        <ConstructionDataItemContainer>
          <Title level={6}>CNPJ da obra (SPE)</Title>

          <span className="description">{constructionData?.receiverCNPJ}</span>
        </ConstructionDataItemContainer>

        <ConstructionDataItemContainer>
          <Title level={6}>Inscrição estadual da obra</Title>

          <span className="description">
            {constructionData?.stateRegistration}
          </span>
        </ConstructionDataItemContainer>
      </ConstructionDataContainerBlock>

      <ConstructionDataContainerBlock>
        <ConstructionDataItemContainer>
          <Title level={6}>CEP</Title>

          <span className="description">{constructionData?.address.cep}</span>
        </ConstructionDataItemContainer>

        <ConstructionDataItemContainer>
          <Title level={6}>Cidade</Title>

          <span className="description">{constructionData?.address.city}</span>
        </ConstructionDataItemContainer>

        <ConstructionDataItemContainer>
          <Title level={6}>Estado</Title>

          <span className="description">{constructionData?.address.state}</span>
        </ConstructionDataItemContainer>
      </ConstructionDataContainerBlock>

      <ConstructionDataContainerBlock>
        <ConstructionDataItemContainer>
          <Title level={6}>Endereço</Title>

          <span className="description">
            {constructionData?.address.address}
          </span>
        </ConstructionDataItemContainer>

        <ConstructionDataItemContainer>
          <Title level={6}>Complemento</Title>

          <span className="description">
            {constructionData?.address.complement || ' - '}
          </span>
        </ConstructionDataItemContainer>

        <ConstructionDataItemContainer>
          <Title level={6}>Torres / Blocos</Title>

          <span className="description">
            {constructionData?.address.towerOption === ETowerOption.UNIQUE
              ? 'Torre ou bloco único'
              : constructionData?.address.towers?.join(', ')}
          </span>
        </ConstructionDataItemContainer>
      </ConstructionDataContainerBlock>
    </ConstructionRegistrationResumeBlock>
  );
};

export default ConstructionDataResume;
